var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.375a2.625 2.625 0 110 5.25 2.625 2.625 0 010-5.25zm0 11.25c3.719 0 7.625 1.819 7.625 2.625v1.375H2.375V16.25c0-.806 3.906-2.625 7.625-2.625zM10 0C7.237 0 5 2.237 5 5c0 2.756 2.237 5 5 5 2.762 0 5-2.244 5-5 0-2.763-2.238-5-5-5zm0 11.25c-3.331 0-10 1.669-10 5V20h20v-3.75c0-3.331-6.669-5-10-5z",
    fill: "#251EB4"
  })));
}
export default SvgAvatar;